const applyTheme = () => {
  const root = document.documentElement;
  root?.style.setProperty('--base-color-1', '#fff');
};

export default applyTheme;
